import { createFilterStore } from './createFilterStore';

export const useLeadFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  status: '',
  source: '',
  assignedToId: '',
  sortBy: 'createdAt',
  sortOrder: 'desc' as const,
});
